import { writable } from "svelte/store"

let box = {
    width: null,
    height: null,
    depth: null,
    unit: null,
};

export default writable(box);

export function stringifyBox() {
    return `b${box.width}x${box.height}x${box.depth}${box.unit}`;
}

export function boxTitle() {
    return `${box.depth} x ${box.width} x ${box.height} ${box.unit}`;
}